module.exports = "/images/logo-safetyiq.svg?a284d2222b3fef5f6e97c9e278e5258c";